export const SUPPORTS_OBJECT_GET_OWN_PROPERTY_NAMES = "getOwnPropertyNames" in Object;
